import { BASE_URL } from '../config/config.js';

export const handleSubmit = async (formData: any) => {
    try {
        const url = `${BASE_URL}/send-email`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        });

        const data = await response.json();
        
        return {
            success: response.ok,
            message: response.ok ? 'Email sent successfully!' : (data.message || 'Failed to send email. Please try again later.')
        };
    } catch (error) {
        return {
            success: false,
            message: 'An error occurred while sending the email. Please check your internet connection and try again.'
        };
    }
};